import { useEffect } from 'react';
import css from './MobileFilter.module.scss';

export default function MobileFilter(props) {
    const { buttons, closeHandler } = props;

    useEffect(() => {
        setTimeout(() => {
            closeHandler();
        }, 3000);
    }, [closeHandler]);

    return (
        <div className={css.filter}>
            {buttons?.map((button) => (
                <div
                    key={Math.random()}
                    className={css.button}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        closeHandler();
                        button.func && button.func();
                    }}
                >
                    {button?.name || '-'}
                </div>
            ))}
        </div>
    );
}
